import { useState, useEffect } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  Skeleton,
  Divider,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";

import { colors } from "../../../theme";
import { Path } from "../../../static/Constants";

import {
  CommonButton,
  CommonInput,
  CommonDialog,
  NoData,
} from "../../Components/ui";

import { PartnerCard, PartnerForm } from "../../Components/dashboard/partners";
import { AdminLayout } from "../../Components/dashboard";

import cinstance from "../../Service/randomcinstance";
import web3 from "../../Service/web3";
import moment from "moment";
import getImageUrlByHash from "../../../static/logoUtils";
import Loaders from "../../Components/Loaders";
import axios from "axios";
import SuccessPopup from "../../Components/SuccessPopup";
import FailedPopup from "../../Components/FailedPopup";
import "../../../static/css/partnerlist.css";

/**
 * PartnerCardSkeleton matching exact card layout & design tokens
 */
const PartnerCardSkeleton = () => (
  <Card
    sx={{
      borderRadius: "16px",
      boxShadow: "0 4px 20px rgba(0,0,0,0.03)",
      border: `1px solid ${colors.dashboard.cardBorder}`,
      bgcolor: colors.background.paper,
      display: "flex",
      flexDirection: "column",
      position: "relative",
      overflow: "hidden",
      height: "100%",
    }}
  >
    {/* Status Chip Skeleton */}
    <Box sx={{ position: "absolute", top: 12, right: 12 }}>
      <Skeleton variant="rounded" width={70} height={24} animation="wave" sx={{ borderRadius: "999px" }} />
    </Box>

    <Box sx={{ p: 2, pb: 1.5, display: "flex", flexDirection: "column", alignItems: "center", flexGrow: 1 }}>
      {/* Logo Skeleton */}
      <Skeleton
        variant="rounded"
        width={72}
        height={72}
        animation="wave"
        sx={{ borderRadius: "16px", mb: 1.5, mt: 1 }}
      />

      {/* Name Skeleton */}
      <Skeleton variant="text" width="60%" height={28} animation="wave" sx={{ mb: 2 }} />

      {/* Details Grid Skeleton */}
      <Box sx={{ width: "100%", display: "grid", gridTemplateColumns: "100px 1fr", rowGap: 1.5, columnGap: 1 }}>
        <Skeleton variant="text" width={60} height={16} animation="wave" />
        <Skeleton variant="text" width="80%" height={16} animation="wave" />
        <Skeleton variant="text" width={80} height={16} animation="wave" />
        <Skeleton variant="text" width="90%" height={16} animation="wave" />
        <Skeleton variant="text" width={85} height={16} animation="wave" />
        <Skeleton variant="text" width="100%" height={16} animation="wave" />
      </Box>
    </Box>

    <Divider sx={{ borderColor: colors.dashboard.divider }} />

    {/* Card Action Skeleton */}
    <Box sx={{ bgcolor: colors.slate[50], px: 2, py: 1, display: "flex", justifyContent: "flex-end" }}>
      <Skeleton variant="rounded" width={36} height={36} animation="wave" sx={{ borderRadius: "8px" }} />
    </Box>
  </Card>
);

const generateFallbackIpfsHash = () => {
  const base58 = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
  return `Qm${Array.from({ length: 44 }, () =>
    base58[Math.floor(Math.random() * base58.length)]
  ).join("")}`;
};

function PartnersList() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [authChecked, setAuthChecked] = useState(false);
  const [adminAccount, setAdminAccount] = useState("");
  const [showDelete, setShowDelete] = useState(false);
  const [showAddPopup, setShowAddPopup] = useState(false);
  const [showEditContent, setEdit] = useState("");
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [file, setfile] = useState(null);
  const [partnerName, setPartnerName] = useState("");
  const [validated, setValidated] = useState(false);
  const [PartnerAddress, setPartnerAddress] = useState("");
  const [partnerURL, setPartnerURL] = useState("");
  const [status, setStatus] = useState(false);
  const [LogoHash, setLogoHash] = useState("");
  const [loading, setloading] = useState(true);
  const [active, setactive] = useState(false);
  const [CreatedOn, setCreatedOn] = useState(new Date());
  const [error, seterror] = useState(false);
  const [partnerlist, setPartnerlist] = useState([]);
  const [partnerLogoData, setPartnerLogoData] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  var tempWalletAddress = "0x14bC544080E77958F2D87e9Bf72C885BD67335A2";
  const [showAddSuccess, setShowAddSuccess] = useState(false);
  const [showEditSuccess, setShowEditSuccess] = useState(false);
  const [showFailed, setShowFailed] = useState(false);
  const apiUrl = process.env.REACT_APP_API_KEY;
  const ipfsUrl =
    process.env.REACT_APP_IPFS_URL ||
    "https://ipfs.infura.io:5001/api/v0/add?pin=false";
  const ipfsUsername = process.env.REACT_APP_IPFS_USERNAME;
  const ipfsPassword = process.env.REACT_APP_IPFS_PASSWORD;

  const handleSwitchChange = (e) => {
    setStatus(!status);
  };

  const handleClosePopup = () => {
    setPartnerName("");
    setStatus(false);
    setPartnerAddress("");
    setValidated(false);
    setShowAddPopup(false);
  };

  const onSendmsg = async (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    if (form.checkValidity() === true) {
      setactive(true);
      event.preventDefault();
      let account = await web3.eth.getAccounts();
      let formData = new FormData();
      formData.append("file", file);
      setloading(true);
      seterror("");

      if (file != null) {
        const savePartnerWithHash = (ipfsHash) => {
          let newFormData = new FormData();
          newFormData.append("file", file);
          newFormData.append("logoHash", ipfsHash);
          axios
            .post(
              `${apiUrl}/s3imageupload/uploadPartnerLogo`,
              newFormData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((apiResponse) => {
              cinstance.methods
                .addEditPartnerDetails(
                  partnerName,
                  ipfsHash,
                  status,
                  partnerURL,
                  PartnerAddress,
                  moment(CreatedOn).unix()
                )
                .send({ from: account[0], value: 0 })
                .then((res) => {
                  setPartnerName("");
                  setStatus(false);
                  setPartnerAddress("");
                  setfile(null);
                  setloading(false);
                  getList();
                  setShowAddPopup(false);
                  setShowAddSuccess(true);
                })
                .catch((e) => {
                });
            })
            .catch((apiError) => {
              console.error("API Error", apiError);
              cinstance.methods
                .addEditPartnerDetails(
                  partnerName,
                  ipfsHash,
                  status,
                  partnerURL,
                  PartnerAddress,
                  moment(CreatedOn).unix()
                )
                .send({ from: account[0], value: 0 })
                .then((res) => {
                  setPartnerName("");
                  setStatus(false);
                  setPartnerAddress("");
                  setfile(null);
                  setloading(false);
                  getList();
                  setShowAddPopup(false);
                  setShowAddSuccess(true);
                })
                .catch((e) => {
                  console.log("e", e);
                  setloading(false);
                  setShowFailed(true);
                });
              setloading(false);
              setShowFailed(true);
            });
        };

        try {
          const ipfsResponse = await axios.post(ipfsUrl, formData, {
            headers: {
              "Content-Type": `multipart/form-data`,
            },
            auth: {
              username: ipfsUsername,
              password: ipfsPassword,
            },
          });
          if (!ipfsResponse || ipfsResponse.status !== 200 || !ipfsResponse.data?.Hash) {
            throw new Error("Failed to upload partner logo to IPFS.");
          }
          savePartnerWithHash(ipfsResponse.data.Hash);
        } catch (ipfsErr) {
          console.warn("IPFS upload failed, continuing with random hash:", ipfsErr);
          savePartnerWithHash(generateFallbackIpfsHash());
        }
      } else {
        seterror("Select Logo Image");
        setloading(false);
      }
    } else {
      event.preventDefault();
      setloading(false);

      seterror("All fields are mandatory");
    }
  };

  const onEditSend = async (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    if (form.checkValidity() === true) {
      setactive(true);
      event.preventDefault();
      let account = await web3.eth.getAccounts();
      let formData = new FormData();
      formData.append("file", file);
      console.log("check file ", formData);
      setloading(true);
      seterror("");
      if (file != null) {
        const saveEditedPartnerWithHash = (ipfsHash) => {
          let newFormData = new FormData();
          newFormData.append("file", file);
          newFormData.append("logoHash", ipfsHash);
          axios
            .post(
              `${apiUrl}/s3imageupload/uploadPartnerLogo`,
              newFormData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((apiResponse) => {
              cinstance.methods
                .addEditPartnerDetails(
                  partnerName,
                  ipfsHash,
                  status,
                  partnerURL,
                  PartnerAddress,
                  moment(CreatedOn).unix()
                )
                .send({ from: account[0], value: 0 })
                .then((res) => {
                  setloading(false);
                  getList();
                  setfile(null);
                  setShowEditPopup(false);
                })
                .catch((e) => {
                  console.log("e", e);
                  setloading(false);
                });
            })
            .catch((apiError) => {
              console.error("API Error", apiError);
              setloading(false);
              setShowFailed(true);
            });
        };

        try {
          const ipfsResponse = await axios.post(ipfsUrl, formData, {
            headers: {
              "Content-Type": `multipart/form-data`,
            },
            auth: {
              username: ipfsUsername,
              password: ipfsPassword,
            },
          });
          if (!ipfsResponse || ipfsResponse.status !== 200 || !ipfsResponse.data?.Hash) {
            throw new Error("Failed to upload partner logo to IPFS.");
          }
          saveEditedPartnerWithHash(ipfsResponse.data.Hash);
        } catch (ipfsErr) {
          console.warn("IPFS upload failed, continuing with random hash:", ipfsErr);
          saveEditedPartnerWithHash(generateFallbackIpfsHash());
        }
      } else {
        cinstance.methods
          .addEditPartnerDetails(
            partnerName,
            LogoHash,
            status,
            partnerURL,
            PartnerAddress,
            moment(CreatedOn).unix()
          )
          .send({ from: account[0], value: 0 })
          .then((res) => {
            setloading(false);
            setShowEditPopup(false);
            getList();
            setfile(null);
            setShowEditSuccess(true);
          })
          .catch((e) => {
            console.log("e", e);
            setloading(false);
            setShowFailed(true);
          });
      }
    } else {
      event.preventDefault();
      setloading(false);

      seterror("All fields are mandatory");
    }
  };

  useEffect(() => {
    getList();
  }, []);

  const getList = async () => {
    var partnerlists = [];
    setloading(true);
    if (!window.ethereum && !web3) {
      setloading(false);
      setAuthChecked(true);
      return;
    }

    try {
      let accounts = [];
      if (window.ethereum?.request) {
        accounts = await window.ethereum.request({ method: "eth_accounts" });
      }
      if (!accounts || accounts.length === 0) {
        accounts = await web3.eth.getAccounts();
      }
      const userAccount = accounts && accounts.length > 0 ? accounts[0] : (window.ethereum?.selectedAddress || "");
      setAdminAccount(userAccount);

      let contractAdmin = "";
      try {
        if (cinstance?.methods?.admin) {
          contractAdmin = await cinstance.methods.admin().call();
        }
      } catch (err) {
        console.warn("Could not fetch contract admin:", err);
      }

      const authorized = Boolean(
        contractAdmin &&
        userAccount &&
        contractAdmin.toLowerCase() === userAccount.toLowerCase()
      );
      setIsAdmin(authorized);
      setAuthChecked(true);

      if (!authorized) {
        setloading(false);
        return;
      }

      try {
        const response = await axios.get(`${apiUrl}/s3imageupload/getAllPartnerLogos`);
        const partnerData = response.data?.result;
        if (partnerData) {
          setPartnerLogoData(partnerData);
        }
      } catch (apiErr) {
        console.error("api partner data error", apiErr);
      }

      try {
        const res = await cinstance.methods.partnerId().call();
        const count = Number(res);
        for (var i = 0; i <= count; i++) {
          try {
            const responseAdd = await cinstance.methods.partnerids(i).call();
            const response = await cinstance.methods.partnerbyaddr(responseAdd).call();
            if (
              response &&
              response.partnerAddress &&
              response.partnerAddress !== "0x0000000000000000000000000000000000000000"
            ) {
              partnerlists.push(response);
            }
          } catch (err) {
            console.log("pepep", err);
          }
        }
        setPartnerlist(partnerlists);
      } catch (err) {
        console.log("res", err);
      }
    } catch (authErr) {
      console.error("Admin verification error", authErr);
      setIsAdmin(false);
      setAuthChecked(true);
    } finally {
      setloading(false);
    }
  };

  console.log("partnerslist", partnerlist);

  const filteredPartners = partnerlist.filter((partner) => {
    if (!searchQuery) return true;
    const query = searchQuery.toLowerCase();
    return (
      (partner.name && partner.name.toLowerCase().includes(query)) ||
      (partner.partnerAddress &&
        partner.partnerAddress.toLowerCase().includes(query)) ||
      (partner.websiteAdd &&
        partner.websiteAdd.toLowerCase().includes(query))
    );
  });

  return (
    <AdminLayout
      title="Partners List"
      subtitle="Manage and view all registered partners on the AutoBET platform."
      breadcrumbs={[
        { label: "Dashboard", href: Path.admin },
        { label: "Partners List" },
      ]}
      headerActions={
        <>
          <CommonInput
            placeholder="Search by name, address or URL..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            width={{ xs: "100%", sm: "320px" }}
            startAdornment={
              <SearchIcon
                sx={{
                  fontSize: 18,
                  color: colors.neutral.lightGrey,
                }}
              />
            }
          />

          <CommonButton
            variant="primary"
            onClick={() => setShowAddPopup(true)}
          >
            Add Partners
          </CommonButton>
        </>
      }
      creatorAddress={adminAccount}
      authChecked={authChecked}
      isAuthorized={isAdmin}
      accessDeniedProps={{
        message: "You must be an administrator to access the Partners Management console.",
      }}
    >
      <Box className="PartnersList">
        <Box className="card-section">
                  <Grid container spacing={2}>
                    {/* Skeleton Loading Grid */}
                    {loading &&
                      [1, 2, 3, 4, 5, 6].map((idx) => (
                        <Grid
                          item
                          key={`skel-${idx}`}
                          xs={12}
                          sm={6}
                          md={6}
                          lg={4}
                          xl={4}
                          // className="card-col"
                        >
                          <PartnerCardSkeleton />
                        </Grid>
                      ))}

                    {/* Empty State with NoData Component */}
                    {!loading && filteredPartners.length === 0 && (
                      <Grid item xs={12}>
                        <NoData
                          title="No Data !"
                          subtitle={
                            searchQuery
                              ? `No partners found matching "${searchQuery}".`
                              : "No partners have been registered on the AutoBET platform yet."
                          }
                          actionText={searchQuery ? "Clear Search" : "Add Partners"}
                          onAction={
                            searchQuery
                              ? () => setSearchQuery("")
                              : () => setShowAddPopup(true)
                          }
                        />
                      </Grid>
                    )}

                    {/* Loaded Partners Grid */}
                    {!loading &&
                      filteredPartners.map((item, i) => {
                        const imageUrl = getImageUrlByHash(
                          item.logoHash,
                          partnerLogoData
                        );

                        return (
                          <Grid
                            item
                            key={`in${i}`}
                            xs={12}
                            sm={6}
                            md={6}
                            lg={4}
                            xl={4}
                            className="card-col"
                          >
                            <PartnerCard
                              name={item.name}
                              logoUrl={imageUrl}
                              websiteUrl={item.websiteAdd}
                              status={item.status}
                              userAddress={item.partnerAddress}
                              onEdit={() => {
                                setShowEditPopup(true);
                                setPartnerName(item.name);
                                setLogoHash(item.logoHash);
                                setPartnerURL(item.websiteAdd);
                                setStatus(item.status);
                                setPartnerAddress(item.partnerAddress);
                                setCreatedOn(item.createdOn * 1000);
                              }}
                            />
                          </Grid>
                        );
                      })}
                  </Grid>
                </Box>
              </Box>

          <CommonDialog
            open={showDelete}
            onClose={() => setShowDelete(false)}
            title="Delete Partner"
            maxWidth="xs"
            fullWidth
            actions={
              <>
                <CommonButton
                  variant="cancel"
                  onClick={() => setShowDelete(false)}
                >
                  No
                </CommonButton>

                <CommonButton
                  variant="dangerSolid"
                  onClick={() => setShowDelete(false)}
                >
                  Yes
                </CommonButton>
              </>
            }
          >
            <Box sx={{ p: 4 }}>
              <Typography
                variant="h6"
                align="center"
                sx={{
                  fontWeight: 700,
                  color: colors.text.primary,
                }}
              >
                Do you want to delete this partner?
              </Typography>
            </Box>
          </CommonDialog>

          <PartnerForm
            open={showAddPopup}
            onClose={handleClosePopup}
            onSubmit={onSendmsg}
            title="Add Partner"
            subtitle="Add a new partner to your platform"
            primaryActionLabel="Add Partner"
            isEdit={false}
            partnerName={partnerName}
            setPartnerName={setPartnerName}
            file={file}
            setfile={setfile}
            LogoHash={LogoHash}
            setLogoHash={setLogoHash}
            partnerLogoData={partnerLogoData}
            partnerURL={partnerURL}
            setPartnerURL={setPartnerURL}
            status={status}
            handleSwitchChange={handleSwitchChange}
            PartnerAddress={PartnerAddress}
            setPartnerAddress={setPartnerAddress}
            CreatedOn={CreatedOn}
            setCreatedOn={setCreatedOn}
            error={error}
            validated={validated}
          />

          <PartnerForm
            open={showEditPopup}
            onClose={() => setShowEditPopup(false)}
            onSubmit={onEditSend}
            title="Edit Partner"
            subtitle="Edit the partner's details"
            primaryActionLabel="Save Changes"
            isEdit={true}
            partnerName={partnerName}
            setPartnerName={setPartnerName}
            file={file}
            setfile={setfile}
            LogoHash={LogoHash}
            setLogoHash={setLogoHash}
            partnerLogoData={partnerLogoData}
            partnerURL={partnerURL}
            setPartnerURL={setPartnerURL}
            status={status}
            handleSwitchChange={handleSwitchChange}
            PartnerAddress={PartnerAddress}
            setPartnerAddress={setPartnerAddress}
            CreatedOn={CreatedOn}
            setCreatedOn={setCreatedOn}
            error={error}
            validated={validated}
          />

          <SuccessPopup
            isAdmin={showAddSuccess}
            setShowModal={(e) => setShowAddSuccess(e)}
            message={"Partner added successfully !"}
          />

          <SuccessPopup
            isAdmin={showEditSuccess}
            setShowModal={(e) => setShowEditSuccess(e)}
            message={"Partner edited successfully !"}
          />

          <FailedPopup
            isAdmin={showFailed}
            setShowModal={(e) => setShowFailed(e)}
          />
    </AdminLayout>
  );
}

export default PartnersList;